import {
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import {
  ApproveCompanyBoardRemuneration,
  ApproveCompanyBoardRemunerationForm,
} from "./approveCompanyBoardRemunerationDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _: DbotEventDispatcher,
  context: DecisionContext<ApproveCompanyBoardRemuneration>,
): ApproveCompanyBoardRemunerationForm {
  return new ApproveCompanyBoardRemunerationForm(context);
}

export function isValid(form: ApproveCompanyBoardRemunerationForm): boolean {
  return form.isValid;
}

export function validate(form: ApproveCompanyBoardRemunerationForm): boolean {
  return form.validate();
}

export function applyForm(
  form: ApproveCompanyBoardRemunerationForm,
): ApproveCompanyBoardRemuneration {
  return {
    type: DecisionType.approveCompanyBoardRemuneration,
    isReceive: form.isReceive.value,
    isDeviatingPeriod: form.isDeviatingPeriod.value,
    deviatingPeriodFrom: form.deviatingPeriodFrom.toISOString(),
    deviatingPeriodTo: form.deviatingPeriodTo.toISOString(),
    period: form.period,
    remuneration: form.selectedRemunerations.map((r) => ({
      id: r.id,
      name: r.name,
      value: r.value.toNumber() ?? 0,
    })),
    isCurrentYear: form.isCurrentYear.value,
  };
}

export const approveCompanyBoardRemunerationHandler: DecisionTypeHandler<
  DecisionType.approveCompanyBoardRemuneration,
  ApproveCompanyBoardRemuneration,
  ApproveCompanyBoardRemunerationForm
> = {
  type: DecisionType.approveCompanyBoardRemuneration,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
